import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let _cache = null;
let _pending = null;

/**
 * Hook to read the published CMS content blocks.
 * Cached in-memory for the whole app session.
 *
 * Usage:
 *   const content = useContent();
 *   content.get("home.hero.title", "Default text");
 */
export function useContent() {
  const [data, setData] = useState(_cache);

  useEffect(() => {
    if (_cache) { setData(_cache); return; }
    if (!_pending) {
      _pending = axios.get(`${API}/content`)
        .then((r) => { _cache = r.data || {}; return _cache; })
        .catch(() => { _cache = {}; return _cache; });
    }
    _pending.then((d) => setData(d));
  }, []);

  return {
    raw: data,
    get: (key, fallback = "") => (data && data[key] ? data[key] : fallback),
  };
}

// For pages that need to force a refresh (admin preview)
export function clearContentCache() {
  _cache = null;
  _pending = null;
}
